import { apiGet, apiPost, apiDelete } from "../lib/api-client";

export interface AnnouncementItem {
  id: string;
  title: string;
  body: string;
  imageUrl: string | null;
  ctaLabel: string | null;
  ctaUrl: string | null;
  createdAt: string;
  dismissedAt: string | null;
}

export interface AdminAnnouncement {
  id: string;
  title: string;
  body: string;
  audience: "all" | "selected" | "new_users";
  imageUrl: string | null;
  ctaLabel: string | null;
  ctaUrl: string | null;
  createdAt: string;
  createdByEmail: string | null;
  recipientCount: number;
  dismissedCount: number;
  recipients: Array<{ userId: string; email: string; name: string | null }>;
}

export function fetchAnnouncements() {
  return apiGet<{ active: AnnouncementItem[]; dismissed: AnnouncementItem[] }>(
    "/announcements",
  );
}

export function dismissAnnouncement(id: string) {
  return apiPost<{ ok: boolean }>(`/announcements/${id}/dismiss`, {});
}

export function fetchAdminAnnouncements() {
  return apiGet<{ announcements: AdminAnnouncement[] }>("/admin/announcements");
}

export function createAdminAnnouncement(input: {
  title: string;
  body: string;
  audience: "all" | "selected" | "new_users";
  userIds?: string[];
  imageUrl?: string;
  ctaLabel?: string;
  ctaUrl?: string;
}) {
  return apiPost<{ announcement: { id: string } }>("/admin/announcements", input);
}

export function getAnnouncementImageUploadUrl(
  contentType: string,
): Promise<{ uploadUrl: string; key: string; publicUrl: string }> {
  return apiPost("/admin/announcements/image-upload-url", { contentType });
}

export function deleteAdminAnnouncement(id: string) {
  return apiDelete<{ ok: boolean }>(`/admin/announcements/${id}`);
}
